import angular from 'angular';

const gamificationsServices = angular.module('applicationModule.gamificationsServices', []);

gamificationsServices.factory('GamificationBadges', ['GamificationBadgesAPI', function (GamificationBadgesAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return GamificationBadgesAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        getActions: function (appId) {
            return GamificationBadgesAPI.getActions(appId);
        },
        get: function (badgeId, appId) {
            return GamificationBadgesAPI.getBadge(badgeId, appId);
        },
        save: function (badge, editMode) {
            if (editMode) {
                return GamificationBadgesAPI.editBadge(badge);
            } else {
                return GamificationBadgesAPI.createBadge(badge);
            }
        },
        remove: function (badgeId, appId) {
            return GamificationBadgesAPI.removeBadge(badgeId, appId);
        }
    };
}]);

gamificationsServices.service('GamificationBadgesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/gamification/badge/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getActions = function (appId) {
        return $http.get(API_URL + 'actions/' + appId);
    };

    this.createBadge = function (badge) {
        return $http.post(API_URL, badge);
    };

    this.getBadge = function (badgeId, appId) {
        return $http.get(API_URL + badgeId, {params: {application_id: appId}});
    };

    this.editBadge = function (badge) {
        return $http.put(API_URL + badge.id, badge);
    };

    this.removeBadge = function (badgeId) {
        return $http.delete(API_URL + badgeId);
    };

}]);

gamificationsServices.factory('GamificationActions', ['GamificationActionsAPI', function (GamificationActionsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return GamificationActionsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        getTypes: function (appId) {
            return GamificationActionsAPI.getTypes(appId);
        },
        get: function (actionId, appId) {
            return GamificationActionsAPI.getAction(actionId, appId);
        },
        save: function (action, editMode) {
            if (editMode) {
                return GamificationActionsAPI.editAction(action);
            } else {
                return GamificationActionsAPI.createAction(action);
            }
        },
        remove: function (actionId) {
            return GamificationActionsAPI.removeAction(actionId);
        }
    };
}]);

gamificationsServices.service('GamificationActionsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/gamification/action/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getTypes = function (appId) {
        return $http.get(API_URL + 'types/' + appId);
    };

    this.createAction = function (action) {
        return $http.post(API_URL, action);
    };
    this.getAction = function (actionId, appId) {
        return $http.get(API_URL + actionId, {params: {application_id: appId}});
    };

    this.editAction = function (action) {
        return $http.put(API_URL + action.id, action);
    };

    this.removeAction = function (actionId) {
        return $http.delete(API_URL + actionId);
    };

}]);

export default gamificationsServices;
